// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__STz3M","logo":"MainNavigation_logo__qEBnu","active":"MainNavigation_active__qng4K","badge":"MainNavigation_badge__4WNNe"};